import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=7c2e828c&scoped=true"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js"
import style0 from "./CompanyDashboard.vue?vue&type=style&index=0&id=7c2e828c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2e828c",
  null
  
)

export default component.exports